import Icon from '../Icon.vue'

Icon.register({
  'hamburger': {
    width: 18,
    height: 14,
    paths: [
      {
        d: 'M0 1a1 1 0 011-1h8a1 1 0 110 2H1a1 1 0 01-1-1zM0 5a1 1 0 011-1h16a1 1 0 110 2H1a1 1 0 01-1-1zM0 9a1 1 0 011-1h12a1 1 0 110 2H1a1 1 0 01-1-1zM0 13a1 1 0 011-1h16a1 1 0 110 2H1a1 1 0 01-1-1z'
      }
    ]
  }
})
